import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import axios from "axios";
import VueAxios from "vue-axios";
import device from "vue-device-detector";
import { API_URL } from "@/common/config";
import "@/assets/css/global.scss";
import i18n from "@/plugins/i18n";
import "@fontsource/roboto";
import "@fontsource/noto-sans-jp";

Vue.use(device);
Vue.config.productionTip = false;
Vue.use(VueAxios, axios);
Vue.axios.defaults.baseURL = API_URL;

let vm = new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
global.vm = vm;
